import DetailRow from './DetailRow'

export * from './DetailRow'

export default DetailRow
